import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LANDING_PATH } from '../../config/accessControl.js';

/**
 * GeoPlay logo in the dashboard sidebar. Clicking takes the user to their landing
 * ({@code LANDING_PATH}). `subtitle` adds a small second line under the
 * name (the sidebar's "LiveOps"); the login and onboarding pages pass none.
 */
export const GeoPlayLogo = ({ expanded, subtitle }) => {
    const navigate = useNavigate();
    return (
        <button
            className="geo-play-logo"
            title="GeoPlay Home"
            type="button"
            onClick={() => navigate(LANDING_PATH)}
        >
            <span className="geo-play-logo-mark">G</span>
            {expanded && (
                <span className="geo-play-logo-words">
                    <span className="geo-play-logo-text">
                        <span className="geo-play-logo-text-geo">Geo</span>
                        <span className="geo-play-logo-text-play">Play</span>
                    </span>
                    {subtitle && <span className="geo-play-logo-subtitle">{subtitle}</span>}
                </span>
            )}
        </button>
    );
};
